import { HypertuneProvider } from 'generated/hypertune.react'
import { PropsWithChildren } from 'react'
import { IS_PROD } from 'constants/envs'
import { REFRESH_INTERVAL_MS } from 'lib/hypertune/constants'
import { Language } from 'types/language'
import hypertuneLib from 'lib/hypertune'
import HypertuneSingletonCreator from 'components/hypertune/HypertuneSingletonCreator'
import { RootArgs } from 'generated/hypertune'

export default function AppHypertuneProvider({ children, lng }: PropsWithChildren<{ lng: Language }>) {
  // Hypertune
  hypertuneLib.setAnonymousIdIfNeeded() // TODO: figure out if needed
  const anonymousId = hypertuneLib.getAnonymousId() ?? ''
  const rootArgs: RootArgs = {
    context: {
      environment: IS_PROD ? 'production' : 'test',
      user: { id: anonymousId, language: lng }
    }
  }

  return (
    <HypertuneProvider
      createSourceOptions={{ token: process.env.NEXT_PUBLIC_HYPERTUNE_TOKEN!, initDataRefreshIntervalMs: REFRESH_INTERVAL_MS }}
      {...{ rootArgs }}
    >
      <HypertuneSingletonCreator {...{ rootArgs }}>{children}</HypertuneSingletonCreator>
    </HypertuneProvider>
  )
}
